<style scoped lang="scss">
.pay-channel-content-div {
    height: 100vh;
    background-color: rgb(242 242 242) !important;
}

.pay-channel-card {
    background-color: white;
    padding: 2rem;
    margin: 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.pay-channel-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #409EFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pay-channel-table {
    width: 100%;
}

.pay-mode-notice {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    padding: 0.9rem 1rem;
    border-radius: 0.7rem;
    margin-bottom: 1rem;

    .notice-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 0.5rem;
        flex-shrink: 0;
    }

    p {
        margin: 0;
        font-size: 0.82rem;
        line-height: 1.6;
        color: #475569;

        strong {
            font-weight: 600;
        }
    }

    &.warning {
        background: #fffbeb;
        border: 1px solid #fde68a;

        .notice-icon {
            background: #fef3c7;
            color: #d97706;
        }

        p strong {
            color: #b45309;
        }
    }

    &.info {
        background: #eff6ff;
        border: 1px solid #bfdbfe;

        .notice-icon {
            background: #dbeafe;
            color: #2563eb;
        }

        p strong {
            color: #1e40af;
        }
    }
}

.pagination {
    margin: 1.5rem auto 0;
    width: fit-content;
}

@media screen and (max-width: 768px) {
    .pay-channel-card {
        margin: 1rem;
        padding: 1.2rem;
    }
}
</style>

<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <UserHeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height: 100vh;overflow: auto;padding-left: 0;background-color: rgb(242, 242, 242) !important;">
                    <div class="pay-channel-content-div">
                        <div class="pay-channel-card">
                            <div class="pay-channel-title">
                                <span>支付通道管理</span>
                                <el-button type="primary" @click="openAddDialog">新增通道</el-button>
                            </div>

                            <!-- 支付方式备注 -->
                            <div class="pay-mode-notice warning" v-if="orderPayMode === 'tenant'">
                                <div class="notice-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        style="width:18px;height:18px">
                                        <path
                                            d="M12 9V13M12 17H12.01M5.07 19H18.93C20.47 19 21.44 17.33 20.66 16L13.73 4C12.96 2.67 11.04 2.67 10.27 4L3.34 16C2.56 17.33 3.53 19 5.07 19Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <p>当前小店为<strong>自定义支付通道</strong>，游客访问小店后，将使用您自定义的支付通道进行支付，请确保余额充足，否则即使支付成功，余额支付开通授权时也会失败。
                                </p>
                            </div>
                            <div class="pay-mode-notice info" v-else-if="orderPayMode === 'system'">
                                <div class="notice-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        style="width:18px;height:18px">
                                        <path
                                            d="M12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16ZM12 8V12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <p>当前小店为<strong>系统支付通道</strong>，游客访问小店后，将使用系统支付通道进行支付，您自定义的支付通道不会生效，游客支付授权成功后，将发放反利给您。
                                </p>
                            </div>

                            <el-table :data="channelList" class="pay-channel-table" v-loading="loading">
                                <el-table-column prop="name" label="通道名称">
                                    <template #default="scope">
                                        <span>{{ scope.row.name || formatPlatform(scope.row.platform) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="platform" label="支付平台" width="100">
                                    <template #default="scope">
                                        <el-tag size="small">{{ formatPlatform(scope.row.platform) }}</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="type" label="支付类型" width="100">
                                    <template #default="scope">
                                        <el-tag size="small" type="info">{{ formatType(scope.row.type) }}</el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="支付方式" width="120">
                                    <template #default="scope">
                                        <span>{{ formatPayMethod(scope.row) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="配置信息" show-overflow-tooltip>
                                    <template #default="scope">
                                        <span>{{ configSummary(scope.row.config) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="state" label="状态" width="80">
                                    <template #default="scope">
                                        <el-tag :type="scope.row.state === 1 ? 'success' : 'info'" size="small">
                                            {{ scope.row.state === 1 ? '启用' : '禁用' }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="150" fixed="right">
                                    <template #default="scope">
                                        <el-button size="small" @click="openEditDialog(scope.row)">编辑</el-button>
                                        <el-button size="small" type="danger"
                                            @click="deleteChannel(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>

                    <!-- 新增/编辑弹窗 -->
                    <el-dialog v-model="dialogVisible" :title="isEdit ? '编辑支付通道' : '新增支付通道'" width="560px">
                        <el-form :model="channelForm" label-width="100px">
                            <el-form-item label="通道名称">
                                <el-input v-model="channelForm.name" placeholder="如：支付宝通道（留空则显示平台名）" />
                            </el-form-item>
                            <el-form-item label="支付平台" required>
                                <el-select v-model="editType" placeholder="选择支付平台" style="width: 100%"
                                    @change="onPlatformChange">
                                    <el-option value="yipay" label="易支付" />
                                    <el-option value="alipay_dmf" label="支付宝当面付" />
                                    <el-option value="alipay_web" label="支付宝网站支付" />
                                </el-select>
                            </el-form-item>
                            <!-- 易支付：选择支持的支付类型（可多选） -->
                            <el-form-item label="支付类型" required v-if="editType === 'yipay'">
                                <el-select v-model="selectedTypes" multiple placeholder="选择支持的支付类型（可多选）"
                                    style="width: 100%">
                                    <el-option value="wxpay" label="微信支付" />
                                    <el-option value="alipay" label="支付宝" />
                                    <el-option value="qqpay" label="QQ支付" />
                                    <el-option value="usdt" label="USDT" />
                                </el-select>
                            </el-form-item>
                            <!-- 易支付配置 -->
                            <template v-if="editType === 'yipay'">
                                <el-form-item label="接口URL" required>
                                    <el-input v-model="channelConfig.url" placeholder="https://pay.example.com" />
                                </el-form-item>
                                <el-form-item label="商户PID" required>
                                    <el-input v-model="channelConfig.pid" placeholder="易支付商户ID" />
                                </el-form-item>
                                <el-form-item label="商户KEY" required>
                                    <el-input v-model="channelConfig.key" placeholder="易支付商户密钥" show-password />
                                </el-form-item>
                            </template>
                            <!-- 支付宝当面付配置 -->
                            <template v-else-if="editType === 'alipay_dmf'">
                                <el-form-item label="AppID" required>
                                    <el-input v-model="channelConfig.app_id" placeholder="支付宝应用ID" />
                                </el-form-item>
                                <el-form-item label="公钥" required>
                                    <el-input v-model="channelConfig.public_key" type="textarea" :rows="3"
                                        placeholder="支付宝公钥" />
                                </el-form-item>
                                <el-form-item label="私钥" required>
                                    <el-input v-model="channelConfig.private_key" type="textarea" :rows="3"
                                        placeholder="应用私钥" />
                                </el-form-item>
                            </template>
                            <!-- 支付宝网站支付配置 -->
                            <template v-else-if="editType === 'alipay_web'">
                                <el-form-item label="AppID" required>
                                    <el-input v-model="channelConfig.app_id" placeholder="支付宝应用ID" />
                                </el-form-item>
                                <el-form-item label="公钥" required>
                                    <el-input v-model="channelConfig.public_key" type="textarea" :rows="3"
                                        placeholder="支付宝公钥" />
                                </el-form-item>
                                <el-form-item label="私钥" required>
                                    <el-input v-model="channelConfig.private_key" type="textarea" :rows="3"
                                        placeholder="应用私钥" />
                                </el-form-item>
                            </template>
                            <el-form-item label="状态">
                                <el-switch v-model="channelForm.state" :active-value="1" :inactive-value="2"
                                    active-text="启用" inactive-text="禁用" />
                            </el-form-item>
                        </el-form>
                        <template #footer>
                            <el-button @click="dialogVisible = false">取消</el-button>
                            <el-button type="primary" @click="submitChannel" :loading="submitting">确认</el-button>
                        </template>
                    </el-dialog>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const channelList = ref<any[]>([])
const loading = ref(false)
const dialogVisible = ref(false)
const isEdit = ref(false)
const submitting = ref(false)
const orderPayMode = ref('')

const channelForm = ref<any>({
    id: 0,
    name: '',
    platform: 1,
    type: '',
    config: '',
    state: 1,
})

// 用于编辑/新增时的配置对象
const channelConfig = ref<Record<string, any>>({})

// 易支付时多选的支付类型
const selectedTypes = ref<string[]>([])

// platform映射：1=易支付，2=支付宝
const formatPlatform = (p: any) => {
    const map: Record<number, string> = { 1: '易支付', 2: '支付宝' }
    return map[p] || '未知'
}

// 解析type为数组（兼容数组、JSON字符串、旧格式如"['alipay']"）
const parseType = (t: any): string[] => {
    if (!t) return []
    if (Array.isArray(t)) return t
    try {
        const parsed = JSON.parse(t)
        if (Array.isArray(parsed)) return parsed
    } catch {
        // 旧格式如 "['alipay']" 不是合法JSON，尝试用正则提取
        const matches = String(t).match(/'([^']+)'/g)
        if (matches) return matches.map(m => m.replace(/'/g, ''))
    }
    return [String(t)]
}

// type映射（支持数组和字符串）
const formatType = (t: any) => {
    if (!t) return '-'
    const typeMap: Record<string, string> = { wxpay: '微信支付', alipay: '支付宝', qqpay: 'QQ支付', usdt: 'USDT' }
    const arr = parseType(t)
    if (arr.length === 0) return '-'
    return arr.map(item => typeMap[item] || item).join('、')
}

// 支付方式：根据platform和config.product_code判断
const formatPayMethod = (row: any) => {
    if (row.platform === 1) return '易支付(跳转)'
    if (row.platform === 2) {
        try {
            const config = typeof row.config === 'string' ? JSON.parse(row.config) : row.config
            if (config.product_code === 'FAST_INSTANT_TRADE_PAY') return '网站支付(跳转)'
            return '当面付(扫码)'
        } catch {
            return '当面付(扫码)'
        }
    }
    return '-'
}

// 编辑时实际使用的通道类型（仅UI使用）
const editType = ref('yipay')

// 根据row数据推断editType
const detectEditType = (row: any): string => {
    if (row.platform === 2) {
        const config = parseConfig(row.config)
        if (config.product_code === 'FAST_INSTANT_TRADE_PAY') return 'alipay_web'
        return 'alipay_dmf'
    }
    return 'yipay'
}

// 切换支付平台时清理无关配置
const onPlatformChange = (newType: string) => {
    if (newType === 'yipay') {
        // 切到易支付，保留易支付字段，清理支付宝字段
        const kept: Record<string, any> = {}
        if (channelConfig.value.url) kept.url = channelConfig.value.url
        if (channelConfig.value.pid) kept.pid = channelConfig.value.pid
        if (channelConfig.value.key) kept.key = channelConfig.value.key
        channelConfig.value = kept
        channelForm.value.platform = 1
    } else if (newType === 'alipay_dmf') {
        // 切到当面付，保留支付宝字段，设置产品码
        const kept: Record<string, any> = {}
        if (channelConfig.value.app_id) kept.app_id = channelConfig.value.app_id
        if (channelConfig.value.public_key) kept.public_key = channelConfig.value.public_key
        if (channelConfig.value.private_key) kept.private_key = channelConfig.value.private_key
        kept.product_code = 'FACE_TO_FACE_PAYMENT'
        channelConfig.value = kept
        channelForm.value.platform = 2
        selectedTypes.value = []
    } else if (newType === 'alipay_web') {
        // 切到网站支付，保留支付宝字段，设置产品码
        const kept: Record<string, any> = {}
        if (channelConfig.value.app_id) kept.app_id = channelConfig.value.app_id
        if (channelConfig.value.public_key) kept.public_key = channelConfig.value.public_key
        if (channelConfig.value.private_key) kept.private_key = channelConfig.value.private_key
        kept.product_code = 'FAST_INSTANT_TRADE_PAY'
        channelConfig.value = kept
        channelForm.value.platform = 2
        selectedTypes.value = []
    }
}

// 配置摘要
const configSummary = (configStr: any) => {
    if (!configStr) return '-'
    try {
        const obj = typeof configStr === 'string' ? JSON.parse(configStr) : configStr
        const keys = Object.keys(obj)
        if (keys.length === 0) return '-'
        return keys.map(k => `${k}=${obj[k]}`).join(', ')
    } catch {
        return String(configStr)
    }
}

// 将 config 字符串解析为编辑用的对象
const parseConfig = (configStr: any): Record<string, any> => {
    if (!configStr) return {}
    try {
        return typeof configStr === 'string' ? JSON.parse(configStr) : { ...configStr }
    } catch {
        return {}
    }
}

// 将配置对象序列化为字符串
const stringifyConfig = (obj: Record<string, any>): string => {
    return JSON.stringify(obj)
}

const getChannelList = async () => {
    loading.value = true
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/payChannels', {}, { headers })
        if (res.data.code === 0) {
            const data = res.data.data
            // 新结构：{ list, order_pay_mode }
            if (data && data.list) {
                channelList.value = data.list
                orderPayMode.value = data.order_pay_mode || ''
            } else if (Array.isArray(data)) {
                // 兼容旧结构
                channelList.value = data
                orderPayMode.value = res.data.order_pay_mode || ''
            } else {
                channelList.value = []
            }
        } else {
            ElMessage.error(res.data.msg || '获取支付通道失败')
        }
    } catch (e: any) {
        ElMessage.error('获取支付通道失败：' + e.message)
    } finally {
        loading.value = false
    }
}

const openAddDialog = () => {
    isEdit.value = false
    channelForm.value = { id: 0, name: '', platform: 1, type: [], config: '', state: 1 }
    editType.value = 'yipay'
    channelConfig.value = {}
    selectedTypes.value = []
    dialogVisible.value = true
}

const openEditDialog = (row: any) => {
    isEdit.value = true
    channelForm.value = { ...row }
    channelConfig.value = parseConfig(row.config)
    editType.value = detectEditType(row)
    // 易支付时初始化多选支付类型
    if (editType.value === 'yipay') {
        selectedTypes.value = parseType(row.type)
    } else {
        selectedTypes.value = []
    }
    dialogVisible.value = true
}

const submitChannel = async () => {
    // 同步platform和type
    if (editType.value === 'yipay') {
        channelForm.value.platform = 1
        if (selectedTypes.value.length === 0) {
            ElMessage.warning('请选择支付类型')
            return
        }
        channelForm.value.type = selectedTypes.value
    } else if (editType.value === 'alipay_dmf') {
        channelForm.value.platform = 2
        channelForm.value.type = ['alipay']
        channelConfig.value.product_code = 'FACE_TO_FACE_PAYMENT'
    } else if (editType.value === 'alipay_web') {
        channelForm.value.platform = 2
        channelForm.value.type = ['alipay']
        channelConfig.value.product_code = 'FAST_INSTANT_TRADE_PAY'
    }
    // 校验配置必填项
    const configValues = Object.values(channelConfig.value).filter(v => v !== undefined && v !== '')
    if (configValues.length === 0) {
        ElMessage.warning('请填写通道配置信息')
        return
    }
    submitting.value = true
    try {
        const url = isEdit.value ? '/api/shop/tenant/payChannel/update' : '/api/shop/tenant/payChannel/add'
        const payload = {
            ...channelForm.value,
            type: JSON.stringify(channelForm.value.type),
            config: stringifyConfig(channelConfig.value),
        }
        const res = await axios.post(baseURL + url, payload, { headers })
        if (res.data.code === 0) {
            ElMessage.success(isEdit.value ? '修改成功' : '添加成功')
            dialogVisible.value = false
            getChannelList()
        } else {
            ElMessage.error(res.data.msg || '操作失败')
        }
    } catch (e: any) {
        ElMessage.error('操作失败：' + e.message)
    } finally {
        submitting.value = false
    }
}

const deleteChannel = (row: any) => {
    ElMessageBox.confirm(`确认删除支付通道「${row.name || formatPlatform(row.platform)}」吗？`, '提示', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(async () => {
        try {
            const res = await axios.post(baseURL + '/api/shop/tenant/payChannel/delete', { id: row.id }, { headers })
            if (res.data.code === 0) {
                ElMessage.success('删除成功')
                getChannelList()
            } else {
                ElMessage.error(res.data.msg || '删除失败')
            }
        } catch (e: any) {
            ElMessage.error('删除失败：' + e.message)
        }
    }).catch(() => { /* 取消 */ })
}

onMounted(() => {
    getChannelList()
})
</script>
